import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@cedcommerce-integration/ounce/dist/index.css";
import { BrowserRouter } from "react-router-dom";
import AuthContext from "./components/utilities/AuthContext/AuthContext";
import { AppProvider } from "@cedcommerce-integration/ounce";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AppProvider>
      <AuthContext>
        <App />
      </AuthContext>
    </AppProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
